"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useContext } from "react";
import TabContext from "./TabsContext.mjs";
import cx from "classnames";
import SSRIcon from "@ingka/ssr-icon";
import { onTabKeyDown } from "./utils/index.mjs";
const Tab = forwardRef(
  (props, ref) => {
    const {
      prefix = "",
      ssrIcon,
      disabled,
      className,
      children,
      text,
      tabPanelId,
      onClick,
      onKeyDown,
      ...otherProps
    } = props;
    const ctx = useContext(TabContext);
    return /* @__PURE__ */ jsxs(
      "button",
      {
        disabled,
        ref,
        ...otherProps,
        className: cx(
          `${prefix}tabs__tab`,
          className,
          ctx.activeTab === tabPanelId && `${prefix}tabs__tab--active`
        ),
        onClick: (e) => {
          const prevent = onClick && onClick(e);
          if (!prevent)
            ctx.setActiveTab(tabPanelId);
        },
        onKeyDown: (e) => {
          const prevent = onKeyDown && onKeyDown(e);
          if (!prevent)
            onTabKeyDown(
              e,
              tabPanelId,
              ctx.setActiveTab,
              ctx.tabs,
              ctx.root || void 0
            );
        },
        role: "tab",
        "aria-selected": ctx.activeTab === tabPanelId,
        "aria-controls": tabPanelId,
        tabIndex: !disabled && ctx.activeTab === tabPanelId ? void 0 : -1,
        children: [
          ssrIcon && /* @__PURE__ */ jsx(SSRIcon, { prefix, paths: ssrIcon }),
          text,
          children
        ]
      }
    );
  }
);
Tab.displayName = "Tab";
var Tab_default = Tab;
export {
  Tab,
  Tab_default as default
};
